let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jk8fF")).then(() => parcelRequire('dh5hf'));